<template>
  <div id="app" :class="viewHeight > 1200 ? 'view' : ''">
        <Layout></Layout>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import Layout from '@/framework/layout'

export default {
  name: 'App',
  components: {
    Layout,
    // LayoutHeader,LayoutFooter
  },
  data() {
    return {
      viewHeight: window.innerWidth,
      layoutMarginLeft: 0,
    }
  },
  created() {

    // 初始化聊天记录缓存
    // if (!localStorage.msgList) {
    //   localStorage.msgList = JSON.stringify({})
    // }
    // if (localStorage.currentChatId) {
    //   localStorage.removeItem('currentChatId')
    //   this.$store.commit('CLEAR_CURRENTCHAT_ID')
    // }
  },
}
</script>

<style lang="less">
@import './framework/style/dialog.less';
@import './framework/style/table.less';
@import './framework/style/layoutLeft.less';
@import './framework/style/button.less';
@import './framework/style/card.less';
@import './framework/style/form';
@import './framework/style/tabs';
@import './framework/style/step';
@import './project/styles/style.less';
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial,
  sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 14px;
  width: 100%;
  //overflow: hidden;
  background: #F5F6F7;
}
.view {
  //overflow-y: hidden;
  overflow-x: auto;
}
li {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue